// Pop-up: send an approved tip back to Pending (reason required).
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { fmtDate, fmtTime } from './helpers.js';

export default function UnapproveModal({ confirmUnapprove, refresh, setUnapproveReason, setUnapproveRow, unapproveBusy, unapproveReason, unapproveRow }) {
  return (
    <>
      {unapproveRow && (
        <div className="modal-backdrop" onClick={() => !unapproveBusy && setUnapproveRow(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 520, maxWidth: 640 }}>
            <h3 style={{ marginTop: 0, color: '#c2410c' }}>Reverse approval?</h3>
            <div className="small" style={{ marginBottom: '0.5rem', color: '#666' }}>
              {fmtDate(unapproveRow.date)} {fmtTime(unapproveRow.arrivalTime)} · {unapproveRow.licensePlate} · {unapproveRow.customer}
            </div>
            <div className="card" style={{ padding: '0.5rem 0.75rem', background: '#fff7ed', marginBottom: '0.75rem', fontSize: '0.9em', color: '#7c2d12' }}>
              <strong>This deletes the row from the Approved DB.</strong>
              {unapproveRow._googleId
                ? <> If this row originated from a driver sheet submission, the matching sheet row will flip back to <strong>Pending Review</strong> so you can correct + re-approve.</>
                : <> This row has no sheet origin (came from the historical seed), so the data is removed entirely. Audit log retains a full snapshot.</>}
            </div>
            <label className="small" style={{ display: 'block', marginBottom: '0.35rem', fontWeight: 600, color: '#991b1b' }}>
              Reason (required — written to audit log)
              <input type="text" value={unapproveReason}
                onChange={e => setUnapproveReason(e.target.value)}
                placeholder="e.g. approved by mistake / customer disputes — re-review needed"
                style={{ width: '100%', borderColor: '#991b1b' }} autoFocus />
            </label>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <button className="refresh-btn" onClick={confirmUnapprove}
                disabled={unapproveBusy || !unapproveReason.trim()}
                style={{ background: '#c2410c' }}>
                {unapproveBusy ? 'Reversing…' : '⤺ Unapprove (write audit + delete)'}
              </button>
              <button className="refresh-btn" onClick={() => setUnapproveRow(null)} disabled={unapproveBusy} style={{ background: '#888' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
